// FollowUpConfirmModal.js
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

const FollowUpConfirmModal = ({ show, onYes, onNo }) => {
  if (!show) return null;

  const modalContent = (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100dvw',
        height: '100dvh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        overflowY: 'auto',
        zIndex: 9999,
        padding: '16px',
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
    >
      <div
        style={{
          width: '100%',
          maxWidth: '400px',
          backgroundColor: 'white',
          borderRadius: '16px',
          padding: '24px',
          marginTop: '10vh',
          boxSizing: 'border-box',
          boxShadow: '0 4px 16px rgba(0,0,0,0.2)',
          maxHeight: 'calc(100dvh - 40px)',
          overflowY: 'auto',
          textAlign: 'center'
        }}
      >
        <p style={{ marginBottom: 24, fontWeight: 'bold', color: '#000000' }}>
          Need Follow up Appointment?
        </p>

        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
            type="button"
            style={{
              backgroundColor: '#C9194A',
              color: '#fff',
              border: 'none',
              width: '140px',
              height: '40px',
              borderRadius: '70px',
              fontWeight: 'bold'
            }}
            onClick={onYes}
          >
            Yes
          </button>

          <button
            type="button"
            style={{
              backgroundColor: '#fff',
              color: '#6C757D',
              border: '1px solid #DEE2E6',
              width: '140px',
              height: '40px',
              borderRadius: '70px',
              fontWeight: 'bold'
            }}
            onClick={onNo}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

FollowUpConfirmModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onYes: PropTypes.func.isRequired,
  onNo: PropTypes.func.isRequired
};

export default FollowUpConfirmModal;
